/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useDebounce } from "react-use";
import { useGetTagsByKeyLazyQuery } from "~/generated/graphql";
import { Autocomplete } from "~/components/Autocomplete";
import { DEBOUNCE_TIMEOUT_MS, FETCH_LIMIT, MINIMAL_LENGTH } from "./constants";

type Props = {
  onChange: (value: string) => void;
};

export function InputName({ onChange }: Props) {
  const [value, setValue] = React.useState("");

  const [getTags, { data, loading }] = useGetTagsByKeyLazyQuery();

  useDebounce(
    () => {
      if (value.length >= MINIMAL_LENGTH) {
        getTags({ variables: { key: value, limit: FETCH_LIMIT } });
      }
    },
    DEBOUNCE_TIMEOUT_MS,
    [value]
  );

  const proposed = data?.searchTagKeys?.keys ?? [];

  return (
    <Autocomplete
      label="Tag Name"
      id="tag-name"
      items={proposed}
      loading={loading}
      value={value}
      onSelect={onChange}
      onChange={(newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
    />
  );
}
